import { SVLoader, SVTable } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import {
  useGetBankAccountDetails,
  useGetTaxDocuments,
} from '@/hooks/requests/useBankAccounts';
import { SVTableRow } from '@/types/common';
import { titleCase } from '@/utils/stringCaser';
import { Card, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import TaxDocumentsManageButton from '../../components/taxDocuments/TaxDocumentsManageButton';
import { ROUTES } from '@/constants/routes';

export default function BankAccountsTaxDocumentsPage() {
  const { uuid = '' } = useParams();
  const { taxDocuments, taxDocumentsIsPending } = useGetTaxDocuments(uuid);
  const { accountDetails, accountsDetailsIsPending } =
    useGetBankAccountDetails(uuid);

  if (taxDocumentsIsPending || accountsDetailsIsPending) {
    return (
      <DefaultLayout header="Tax Documents">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!accountDetails) {
    return (
      <DefaultLayout header="Tax Documents">
        <Card>
          <Typography>
            Something went wrong retreiving the bank account transactions. Our
            team has been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const rows: SVTableRow[] = taxDocuments.map(document => {
    const { uuid, name, status } = document;

    return {
      key: `documentRow${uuid}`,
      cells: [
        {
          key: `name${uuid}`,
          type: 'text',
          content: name,
        },
        {
          key: `status${uuid}`,
          type: 'text',
          content: titleCase(status.replace('_', ' ')),
        },
        {
          key: `url${uuid}`,
          type: 'custom',
          content: <TaxDocumentsManageButton taxDocument={document} />,
        },
      ],
    };
  });

  return (
    <DefaultLayout
      header="Tax Documents"
      breadcrumb={[
        { label: 'Bank Accounts', href: ROUTES.BANK_ACCOUNTS },
        { label: 'Details', href: `${ROUTES.BANK_ACCOUNTS}/${uuid}` },
        { label: 'Tax Documents', isActive: true },
      ]}>
      <Card>
        <SVTable
          ariaLabel="Tax Documents"
          headers={[
            { key: 'name', content: 'Name' },
            { key: 'status', content: 'Status' },
            { key: 'manage', content: '' },
          ]}
          rows={rows}
          emptyTableContent="This bank account has no tax documents"
        />
      </Card>
    </DefaultLayout>
  );
}
